'use strict';
const angular = require('angular');

export class modalButtonWidgetComponent {

  constructor(DynamicPageService, $uibModal, $scope) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.DynamicPageService = DynamicPageService;
    this.$scope = $scope;
  }

  openModal() {
    let ref = this.$uibModal.open({
      template: this.html,
      size: this.modalSize,
      scope: this.$scope
    });

    ref.result.then(
        _ => { /* ok */ },
        _ => { /* cancel */ }
      );
  }

  $onInit() {

    this.modalSize = this.size || 'md';
    this.buttonClass = this.btnClass ? 'btn-' + this.btnClass : 'btn-primary';
    this.buttonSize = this.btnSize ? 'btn-' + this.btnSize : '';

    this.DynamicPageService.getByName({name: this.content}, page => {
      this.html = this.convertShortcode(page.data);
    }, err => {
      console.log('could not retrieve dynamic page for modal');
    });
  }

  convertShortcode(html) {
    return html.replace(/\[/g,"<").replace(/\]/g,">");
  }
}

export default angular.module('conduuApp.modalButtonWidgetComponent', [])
  .component('modalButtonWidget', {
    template: require('./modal-button-widget.component.html'),
    bindings: {
      content: '@',
      btnClass: '@',
      btnSize: '@',
      label: '@',
      size: '@',
      dismiss: '&'
    },
    controller: modalButtonWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/modal-button-widget/modal-button-widget.component.js